const USERS_REFRESH_MS = [0, 15_000, 30_000, 60_000, 120_000] as const;

export type UsersRefreshMs = (typeof USERS_REFRESH_MS)[number];

const DEFAULT_USERS_REFRESH_MS: UsersRefreshMs = 30_000;

const STORAGE_KEY = "play-admin.users-refresh-ms";

export function parseUsersRefreshMs(raw: unknown): UsersRefreshMs {
	if (raw == null || raw === "") {
		return DEFAULT_USERS_REFRESH_MS;
	}
	const value = typeof raw === "number" ? raw : Number(raw);
	return (USERS_REFRESH_MS as readonly number[]).includes(value)
		? (value as UsersRefreshMs)
		: DEFAULT_USERS_REFRESH_MS;
}

export function readUsersRefreshMs(): UsersRefreshMs {
	try {
		return parseUsersRefreshMs(window.localStorage.getItem(STORAGE_KEY));
	} catch {
		return DEFAULT_USERS_REFRESH_MS;
	}
}

export function persistUsersRefreshMs(ms: UsersRefreshMs) {
	try {
		window.localStorage.setItem(STORAGE_KEY, String(ms));
	} catch {
		/* ignore quota / private mode */
	}
}
